import React from 'react';
import { cx } from '../cx';

// D-09 §15.30 — Divider (.divider)
export function Divider({ className = '', ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cx('divider', className)} {...props} />;
}
